const navigation = document.querySelector('.navigation');
const actionMenu = document.querySelector('.action--menu');
const navigationMenu = document.querySelector('.navigation__menu');

if (actionMenu && navigationMenu) {
  actionMenu.addEventListener('click', e => {
    e.preventDefault();
    actionMenu.classList.toggle('open');
    navigationMenu.classList.toggle('active');

    // Update the aria-label based on the state
    if (actionMenu.classList.contains('open')) {
      actionMenu.setAttribute('aria-label', 'Close Menu');
    } else {
      actionMenu.setAttribute('aria-label', 'Open Menu');
    }
  });
}
